<div class="card-control-container">
    <div *ngIf="cardInfo.showCardControllers" >
        <div class="card-control-items-area">
            <div>
                <!--<i class="fas fa-arrows-alt" hidden></i>-->
            </div>
            <div class="card-control-dropdown" *ngIf="cardInfo.showDropdown">
                <mat-icon *ngIf="isCustomDashboard && false"
                        class="fas fa-filter card-control-area-icon-filter"
                        (click)="cardControlFilterIconClick('card-control-filter-content-' + cardInfo.cardId)"
                ></mat-icon>
                <mat-icon
                        class="fal fa-ellipsis-h card-control-area-icon-dots"
                        (click)="cardControlDotsIconClick('card-control-dropdown-content-' + cardInfo.cardId)"
                ></mat-icon>
                <div
                        class="card-control-dropdown-content"
                        id="card-control-dropdown-content-{{ cardInfo.cardId }}"
                >
                    <div
                            class="card-control-dropdown-close"
                            (click)="cardControlDotsIconClick('card-control-dropdown-content-' + cardInfo.cardId)"
                    >
                        <i class="fas fa-times"></i>
                    </div>
                    <div class="card-control-dropdown-item" (click)="cardControlItemSelect()">
                        {{ corporateDasboardText }}
                    </div>
                </div>
            </div>       
        </div>
    </div>
</div>
